import Action from "../Action";
export default class RamAction extends Action {
    constructor() {
        super();
        this._name = "RamAction";
    }
}
